window.REBASE = window.REBASE || {};
REBASE.theme = {};

(function ($) {

  /**
   * Privacy Policy Footer Link
   * 
   * This is a custom script to handle the privacy policy footer link.
   * It is used to toggle the privacy policy modal.
   * 
   */
  const privacyPolicyFooterLink = document.querySelector('[title="Go to Your Privacy Choices"]');
  if (privacyPolicyFooterLink) {
    privacyPolicyFooterLink.addEventListener("click", function (e) {
      e.preventDefault();
      if (typeof OneTrust !== "undefined" && typeof OneTrust.ToggleInfoDisplay === "function") {
        OneTrust.ToggleInfoDisplay();
      } else {
        console.warn("OneTrust or its function not available yet.");
      }
    });
  }

  // Get the query parameters from the URL
const params = new URLSearchParams(window.location.search);

// Check if showModal=1
if (params.get('showModal') === '1') {
    const maxWaitTime = 5000; // max wait 5 seconds
    const intervalTime = 500;  // check every 0.5 seconds
    let waited = 0;

    const checkOneTrust = setInterval(() => {
        waited += intervalTime;

        if (typeof OneTrust !== "undefined" && typeof OneTrust.ToggleInfoDisplay === "function" && waited >= 5000) {
            // Call the function after 5+ seconds and OneTrust is available
            OneTrust.ToggleInfoDisplay();
            clearInterval(checkOneTrust);
        }

        // Stop checking after maxWaitTime even if OneTrust isn't ready
        if (waited >= maxWaitTime) {
            clearInterval(checkOneTrust);
            console.warn("OneTrust was not ready in time.");
        }
    }, intervalTime);
}
  
  /* ----------------------------------------------------------------
  -------------------------------------------------------------------
  Main Script
  -------------------------------------------------------------------
  -----------------------------------------------------------------*/

  $(function () {
    /* ----------------------------------------------------------------
    Initializations
    -----------------------------------------------------------------*/

    // Rehash miniCart Initialization
    // window.miniCart = new MiniCart({
    //   addToCartFormId: 'add-item-form',
    //   containerId: 'minicart-container',
    //   toggleBtnClass: 'minicart-toggle-btn',
    //   quickAddToCartBtnClass: 'minicart-quick-add-to-cart-btn',
    //   cartCountClass: 'cart-item-count',
    //   scrollToAfterAdd: false,
    //   showBackground: true,
    //   showQtyAction: true,
    //   showCheckoutAction: false,
    //   showSubtotal: true,
    //   header: 'Your Cart'
    // });

    /* ----------------------------------------------------------------
    Navigation
    -----------------------------------------------------------------*/
    // Mobile Navigation
    var mmStatus = "closed";

    function closeMM() {
      mmStatus = "closed";
      $("#mobile-navigation-toggle").toggleClass("opened");
      $("body").removeClass("nav-opened");
    }

    function openMM() {
      mmStatus = "opened";
      $("body").addClass("nav-opened");
      $("#mobile-navigation-toggle").toggleClass("opened");
    }

    $("#mobile-navigation-toggle").on("click", function () {
      if (mmStatus == "closed") {
        openMM();
      } else if (mmStatus == "opened") {
        closeMM();
      }
      return false;
    });
    $(".mobile-dropdown-toggle").on("click", function () {
      $(this).next().toggle();
    });

    function showDD() {
      $(".hover-intent").removeClass("hovered");
      $(this).toggleClass("hovered");
    }

    function hideDD() {
      $(this).removeClass("hovered");
    }
    /* main navigation */
    $(".hover-intent").hoverIntent({
      over: showDD,
      out: hideDD,
      timeout: 350,
    });

    /* ----------------------------------------------------------------
    jQuery toggles
    -----------------------------------------------------------------*/

    //Login Page - forgot password toggle
    $("#forgot-password-link").on("click", function (e) {
      e.preventDefault();
      $("#recover-password-form").show();
      $("#customer-login-form").hide();
    });

    $("#forgot-password-cancel").on("click", function (e) {
      e.preventDefault();
      $("#recover-password-form").hide();
      $("#customer-login-form").show();
    });

    /* ----------------------------------------------------------------
    Rebase Places app custom integration (inject grooming buttons)
    -----------------------------------------------------------------*/
    if ($("body").is("#store-locator-id")) {
      var GROOMING = [
          { name: "Searcy, AR", handle: "/pages/searcy" },
          { name: "Corinth, MS", handle: "/pages/corinth" },
          { name: "Griffin, GA", handle: "/pages/griffin" },
          { name: "Covington, GA", handle: "/pages/covington" },
          { name: "Franklin, TN", handle: "/pages/franklin" },
          { name: "Cottonwood, AZ", handle: "/pages/cottonwood" },
          { name: "The Villages, FL", handle: "/pages/villages" },
          { name: "Enterprise, AL", handle: "/pages/enterprise" },
          { name: "Showlow, AZ", handle: "/pages/showlow" },
          { name: "Hinesville, GA", handle: "/pages/hinesville" },
          { name: "Granbury, TX", handle: "/pages/granbury" },
          { name: "Hampton Cove, AL", handle: "/pages/hampton-cove" },
          { name: "Grovetown, GA", handle: "/pages/grovetown" },
          { name: "Chehalis, WA", handle: "/pages/chehalis" },
          { name: "Tahlequah, OK", handle: "/pages/tahlequah" },
          { name: "Conway, SC", handle: "/pages/conway" },
          { name: "Fort Oglethorpe, GA", handle: "/pages/fort-oglethorpe" },
          { name: "Durant, OK", handle: "/pages/durant" },
          { name: "Crestview, FL", handle: "/pages/crestview" },
          { name: "Norton, VA", handle: "/pages/norton" },
          { name: "Pittsburg, KS", handle: "/pages/pittsburg" },
          { name: "Hobbs, NM", handle: "/pages/hobbs" },
          { name: "Lake Wylie, SC", handle: "/pages/lake-wylie" },
          { name: "Ponca City, OK", handle: "/pages/ponca-city" },
          { name: "Moultrie, GA", handle: "/pages/moultrie" },
          { name: "Eastchase, TX", handle: "/pages/eastchase" },
          { name: "McComb, MS", handle: "/pages/mccomb" },
          { name: "Thibodaux, LA", handle: "/pages/thibodaux" },
          { name: "Henderson, TX", handle: "/pages/henderson-tx" },
          { name: "Vicksburg, MS", handle: "/pages/vicksburg" },
          { name: "Del Rio, TX", handle: "/pages/del-rio" },
          { name: "Gun Barrel City, TX", handle: "/pages/gun-barrel-city" },
          { name: "Laurel, MS", handle: "/pages/laurel" },
          { name: "Alamogordo, NM", handle: "/pages/alamogordo" },
          { name: "Marshall, TX", handle: "/pages/marshall" },
          { name: "Little Rock, AR", handle: "/pages/north-little-rock" },
          { name: "Sulphur Springs, TX", handle: "/pages/sulphur-springs" },
          { name: "Brookhaven, MS", handle: "/pages/brookhaven" },
          { name: "Lebanon, MO", handle: "/pages/lebanon-mo" },
          { name: "Ruston, LA", handle: "/pages/ruston" },
          { name: "Brownwood, TX", handle: "/pages/brownwood" },
          { name: "Brandon, MS", handle: "/pages/brandon" },
          { name: "Cedar City, UT", handle: "/pages/cedar-city" },
          { name: "La Grande, OR", handle: "/pages/la-grande" },
          { name: "Sapulpa, OK", handle: "/pages/sapulpa" },
          { name: "Ada, OK", handle: "/pages/ada" },
          { name: "Middleburg, FL", handle: "/pages/middleburg" },
          { name: "Mt. Dora, FL", handle: "/pages/mt-dora" },
          { name: "Hays, KS", handle: "/pages/hays" },
          { name: "Rio Rancho, NM", handle: "/pages/rio-rancho" },
          { name: "Signal Mountain, TN", handle: "/pages/signal-mountain" },
          { name: "Clovis, NM", handle: "/pages/clovis" },
          { name: "Batesville, AR", handle: "/pages/batesville" },
          { name: "Columbia, TN", handle: "/pages/columbia-tn" },
          { name: "Jamestown, NC", handle: "/pages/jamestown" },
          { name: "Highland City, FL", handle: "/pages/highland-city" },
          { name: "Auburndale, FL", handle: "/pages/auburndale" },
          { name: "Ocala, FL", handle: "/pages/ocala" },
          { name: "Marco Island, FL", handle: "/pages/marco-island" },
          { name: "Sebastian, FL", handle: "/pages/sebastian" },
          { name: "Dyersburg, TN", handle: "/pages/dyersburg" },
          { name: "Nokomis, FL", handle: "/pages/nokomis" },
          { name: "Sherrills Ford, NC", handle: "/pages/sherrills-ford" },
          { name: "Poinciana, FL", handle: "/pages/poinciana" },
          { name: "Niceville, FL", handle: "/pages/niceville" },
        ],
        VET_SERVICES = [
          { store_number: 7001, name: "Tulare, CA", type: "VIP" },
          { store_number: 7002, name: "Commerce, GA", type: "ShotVet" },
          { store_number: 7004, name: "Nacogdoches, TX", type: "ShotVet" },
          { store_number: 7009, name: "Hobbs, NM", type: "IND" },
          { store_number: 7012, name: "Mount Airy, NC", type: "VIP" },
          { store_number: 7013, name: "Albemarle, NC", type: "VIP" },
          { store_number: 7016, name: "Orangeburg, SC", type: "VIP" },
          { store_number: 7017, name: "Searcy, AR", type: "IND" },
          { store_number: 7018, name: "Kinston, NC", type: "ShotVet" },
          { store_number: 7021, name: "Lenoir, NC", type: "VIP" },
          { store_number: 7022, name: "Elizabeth City, NC", type: "VIP" },
          { store_number: 7023, name: "Tahlequah, OK", type: "VIP" },
          { store_number: 7027, name: "Corinth, MS", type: "IND" },
          { store_number: 7028, name: "Thomaston, GA", type: "VIP" },
          { store_number: 7029, name: "Batesville, AR", type: "IND" },
          { store_number: 7030, name: "Reidsville, NC", type: "VIP" },
          { store_number: 7031, name: "Chehalis, WA", type: "VIP" },
          { store_number: 7037, name: "Griffin, GA", type: "VIP" },
          { store_number: 7039, name: "Dublin, GA", type: "VIP" },
          { store_number: 7040, name: "Seymour, IN", type: "VIP" },
          { store_number: 7041, name: "Pine Bluff, AR", type: "VIP" },
          { store_number: 7042, name: "Showlow, AZ", type: "VIP" },
          { store_number: 7044, name: "Carlsbad, NM", type: "IND" },
          { store_number: 7045, name: "Thomasville, GA", type: "VIP" },
          { store_number: 7048, name: "Hammond, LA", type: "VIP" },
          { store_number: 7049, name: "Aberdeen, WA", type: "VIP" },
          { store_number: 7051, name: "Shallotte, NC", type: "VIP" },
          { store_number: 7052, name: "Austin, TX", type: "IND" },
          { store_number: 7055, name: "Zachary, LA", type: "ShotVet" },
          { store_number: 7058, name: "Hinesville, GA", type: "VIP" },
          { store_number: 7060, name: "Greensboro, NC", type: "VIP" },
          { store_number: 7061, name: "Goose Creek, SC", type: "VIP" },
          { store_number: 7062, name: "Lebanon, TN", type: "VIP" },
          { store_number: 7064, name: "Cedar City, UT", type: "VIP" },
          { store_number: 7066, name: "Norwich, CT", type: "VIP" },
          { store_number: 7068, name: "Columbia, TN", type: "IND" },
          { store_number: 7069, name: "Milledgeville, GA", type: "ShotVet" },
          { store_number: 7070, name: "Sevierville, TN", type: "VIP" },
          { store_number: 7071, name: "Marshall, TX", type: "ShotVet" },
          { store_number: 7072, name: "Brownwood, TX", type: "VIP" },
          { store_number: 7073, name: "Morristown, TN", type: "VIP" },
          { store_number: 7074, name: "LaGrange, GA", type: "VIP" },
          { store_number: 7075, name: "Eastchase, TX", type: "VIP" },
          { store_number: 7077, name: "Cottonwood, AZ", type: "VIP" },
          { store_number: 7079, name: "Elizabethton, TN", type: "ShotVet" },
          { store_number: 7080, name: "Columbia, SC", type: "VIP" },
          { store_number: 7081, name: "Los Lunas, NM", type: "IND" },
          { store_number: 7083, name: "Tifton, GA", type: "ShotVet" },
          { store_number: 7084, name: "Granbury, TX", type: "VIP" },
          { store_number: 7087, name: "Conway, SC", type: "VIP" },
          { store_number: 7089, name: "Lancaster, SC", type: "VIP" },
          { store_number: 7090, name: "Fort Oglethorpe, GA", type: "VIP" },
          { store_number: 7094, name: "Lumberton, NC", type: "ShotVet" },
          { store_number: 7095, name: "Athens, TN", type: "ShotVet" },
          { store_number: 7096, name: "Gallatin, TN", type: "IND" },
          { store_number: 7097, name: "Mebane, NC", type: "IND" },
          { store_number: 7101, name: "Wilmington, NC", type: "VIP" },
          { store_number: 7102, name: "Crossville, TN", type: "VIP" },
          { store_number: 7104, name: "Rio Rancho, NM", type: "IND" },
          { store_number: 7105, name: "Cleburne, TX", type: "VIP" },
          { store_number: 7106, name: "Covington, GA", type: "VIP" },
          { store_number: 7111, name: "Clemmons, NC", type: "ShotVet" },
          { store_number: 7114, name: "Albuquerque, NM", type: "IND" },
          { store_number: 7118, name: "Chickasha, OK", type: "VIP" },
          { store_number: 7124, name: "Gun Barrel City, TX", type: "ShotVet" },
          { store_number: 7125, name: "Uvalde, TX", type: "VIP" },
          { store_number: 7126, name: "Jasper, GA", type: "ShotVet" },
          { store_number: 7127, name: "Ellensburg, WA", type: "VIP" },
          { store_number: 7128, name: "Lebanon, MO", type: "VIP" },
          { store_number: 7131, name: "Murfreesboro, TN", type: "ShotVet" },
          { store_number: 7135, name: "Little Rock, AR", type: "VIP" },
          { store_number: 7137, name: "Clovis, NM", type: "IND" },
          { store_number: 7138, name: "Laurinburg, NC", type: "VIP" },
          { store_number: 7141, name: "Lake Wylie, SC", type: "VIP" },
          { store_number: 7142, name: "Lenoir City, TN", type: "ShotVet" },
          { store_number: 7143, name: "Franklin, TN", type: "VIP" },
          { store_number: 7145, name: "Hermiston, OR", type: "IND" },
          { store_number: 7147, name: "Moultrie, GA", type: "ShotVet" },
          { store_number: 7148, name: "LaFollette, TN", type: "VIP" },
          { store_number: 7150, name: "St Robert, MO", type: "VIP" },
          { store_number: 7151, name: "Athens, GA", type: "ShotVet" },
          { store_number: 7152, name: "Sullivan, MO", type: "VIP" },
          { store_number: 7153, name: "Danville, KY", type: "VIP" },
          { store_number: 7156, name: "Opelousas, LA", type: "VIP" },
          { store_number: 7158, name: "Henderson, TX", type: "ShotVet" },
          { store_number: 7160, name: "Del Rio, TX", type: "VIP" },
          { store_number: 7162, name: "Sulphur, LA", type: "ShotVet" },
          { store_number: 7163, name: "Abbeville, LA", type: "VIP" },
          { store_number: 7164, name: "Cape Carteret, NC", type: "ShotVet" },
          { store_number: 7167, name: "Leland, NC", type: "VIP" },
          { store_number: 7169, name: "Gulf Breeze, FL", type: "ShotVet" },
          { store_number: 7172, name: "Crestview, FL", type: "ShotVet" },
          { store_number: 7173, name: "Grovetown, GA", type: "ShotVet" },
          { store_number: 7174, name: "Shelbyville, TN", type: "VIP" },
          { store_number: 7176, name: "Thibodaux, LA", type: "VIP" },
          { store_number: 7177, name: "Lindale, TX", type: "ShotVet" },
          { store_number: 7178, name: "LaPlace, LA", Type: "ShotVet" },
          { store_number: 7185, name: "Dunn, NC", type: "ShotVet" },
          { store_number: 7186, name: "Signal Mountain, TN", type: "VIP" },
          { store_number: 7188, name: "Palatka, FL", type: "ShotVet" },
          { store_number: 7190, name: "Middleburg, FL", type: "ShotVet" },
          { store_number: 7191, name: "St. Mary's, GA", type: "ShotVet" },
          { store_number: 7192, name: "The Villages, FL", type: "ShotVet" },
          { store_number: 7193, name: "Mt. Dora, FL", type: "ShotVet" },
          { store_number: 7194, name: "Villa Rica, GA", type: "ShotVet" },
          { store_number: 7195, name: "Beverly Hills, FL", type: "ShotVet" },
          { store_number: 7202, name: "Clayton, NC", type: "ShotVet" },
          { store_number: 7203, name: "Highland City, FL", type: "ShotVet" },
          { store_number: 7211, name: "Jamestown, NC", type: "ShotVet" },
        ],
        GROOMING_EXCLUSIONS = [
          "Tulare, CA",
          "Commerce, GA",
          "Nacogdoches, TX",
          "Aberdeen, WA",
          "Zachary, LA",
          "Kingsville, TX",
        ];

      $(document).on(
        "places-displayed-new-results places-displayed-existing-results",
        function (e) {
          var results_placeholders = $(".rb__places-list-item--placeholder");

          if (e.detail && results_placeholders.length === e.detail.length) {
            e.detail.map(function (x, indx) {
              var extra_html = "",
                // IMPORTANT: rebase-libs polyfills Array.find for us
                vet_match = VET_SERVICES.find(function (xx) {
                  return x.info.name === xx.name;
                }),
                grooming_match = GROOMING.find(function (xx) {
                  return x.info.name === xx.name;
                });

              if (vet_match) {
                switch (vet_match.type) {
                  case "VIP":
                    extra_html +=
                      '<a target="_blank" rel="nofollow noreferrer noopener" href="https://www.vippetcare.com/find-a-location/" class="vet-services btn btn--alt">Veterinary Services</a>';
                    break;
                  case "ShotVet":
                    extra_html +=
                      '<a target="_blank" rel="nofollow noreferrer noopener" href="https://www.shotvet.com/find-a-clinic/" class="vet-services btn btn--alt">Veterinary Services</a>';
                    break;
                  case "IND":
                    extra_html +=
                      '<span class="book-grooming">Call to book vet services</span>';
                    break;
                  default:
                    extra_html +=
                      '<span class="book-grooming">Call to book vet services</span>';
                }
              }

              if (grooming_match) {
                extra_html +=
                  '<a href="' +
                  grooming_match.handle +
                  '" class="book-grooming btn">Book grooming online</a>';
              } else {
                if (!GROOMING_EXCLUSIONS.includes(x.info.name)) {
                  extra_html +=
                    '<span class="book-grooming">Call to book grooming</span>';
                }
              }

              results_placeholders.eq(indx).html(extra_html);
            });
          } else {
            console.warn("PLACES results length did not match");
          }
        }
      );
    }
    /* ----------------------------------------------------------------
    End of Store Location Lookup and Saving
    -----------------------------------------------------------------*/

    // Goes through all header and footer links, if link is not equal to host name, add target="_blank"
    const headerLinks = document
      .querySelector(".header-main")
      .getElementsByTagName("a");
    const footerLinks = document
      .querySelector(".footer-navigation")
      .getElementsByTagName("a");
    const links = [...headerLinks, ...footerLinks];
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = "_blank";
        links[i].rel = "noreferrer noopener";
      }
    }

    function waitForElm(selector) {
      return new Promise((resolve) => {
        if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver((mutations) => {
          if (document.querySelector(selector)) {
            resolve(document.querySelector(selector));
            observer.disconnect();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      });
    }

    // Util function to override default og subscription page behaviour
    const OGSubscriptionPage = () => {
      const OGContainer = document.querySelector("og-smi");

      // If og-smi container doesnt exist, do nothing;
      if (!OGContainer) {
        return;
      }

      // Wait for mobile payment shipping element to load, once loaded set attribute to open
      waitForElm(".og-mobile-payment-shipping").then((element) => {
        element.setAttribute("open", true);
      });
    };

    OGSubscriptionPage();
  });
})(jQuery);
